import { render, staticRenderFns } from "./AgentOrders.vue?vue&type=template&id=889a40dc&scoped=true&"
import script from "./AgentOrders.vue?vue&type=script&lang=js&"
export * from "./AgentOrders.vue?vue&type=script&lang=js&"
import style0 from "./AgentOrders.vue?vue&type=style&index=0&id=889a40dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889a40dc",
  null
  
)

export default component.exports